import { Box, Stack } from '@mui/material'

type Props = {
  children: React.ReactNode | React.ReactNode[]
}

export const SearchBar = ({ children }: Props) => {
  return (
    <Box component="div" sx={{ p: 2, backgroundColor: 'grey.200' }}>
      <Stack direction={{ sm: 'column', xs: 'column', md: 'row' }} spacing={1} sx={{ justifyContent: 'space-between' }}>
        {children}
      </Stack>
    </Box>
  )
}
